var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.wrapperProfile
  }, [_c('div', [_c('h2', {
    class: _vm.$style.heading
  }, [_vm._v("\n        Cпасибо!\n      ")])]), _vm._v(" "), _c('p', {
    class: _vm.$style.message
  }, [_vm._v("\n      Пожалуйста, проверьте свою электронную почту.\n    ")])]), _vm._v(" "), _c('div', [_c('SButton', {
    class: _vm.$style.btn,
    attrs: {
      "theme": "primary",
      "rounded": "",
      "size": "x-large"
    },
    on: {
      "click": function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("\n      Закрыть\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };